module.exports = __webpack_public_path__ + "static/media/logo.6a90e4b2.png";